import { create } from 'zustand';

function getStoredData() {
  try {
    const raw = localStorage.getItem("bushe_local")
    if (raw) {
      const parsed = JSON.parse(raw)
      return {
        permissions: parsed?.user?.permissions ?? [],
        resourceAccess: parsed?.user?.resourceAccess ?? {},
      }
    }
  } catch (e) { /* ignore */ }
  return { permissions: [], resourceAccess: {} }
}

const storedData = getStoredData()

export const useAppData = create((set) => ({
  user: null,
  setUser: (data: {email:string, name: string, role: string}) => set({user: data}),
  permissions: storedData.permissions,
  setPermissions: (permissions: string[]) => set({permissions}),
  resourceAccess: storedData.resourceAccess,
  setResourceAccess: (resourceAccess: Record<string, number[]>) => set({resourceAccess}),
  layoutConfig: {
    isMobile: false,
    collapsed: true,
    siderWidth: 80
  },
  setLayoutConfig: (layoutConfig: {isMobile: boolean, collapsed: boolean, siderWidth: number}) => set({layoutConfig}),
}));
